import React from "react";
import {
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Button,
  Dialog,
} from "@material-ui/core";

export const ConfirmModal = ({ show, onHide, articleName, deleteArticle }) => {
  return (
    <Dialog
      open={show}
      onClose={onHide}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form onSubmit={(e) => deleteArticle(e)}>
        <DialogTitle>Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>"{articleName}"?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={onHide}>
            No
          </Button>
          <Button color="primary" type="submit">
            Yes
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
